module.exports = __webpack_public_path__ + "img/avatar2.26a88af7.png";